import { render, staticRenderFns } from "./loadingPagination.vue?vue&type=template&id=8110187c&scoped=true&"
import script from "./loadingPagination.vue?vue&type=script&lang=js&"
export * from "./loadingPagination.vue?vue&type=script&lang=js&"
import style0 from "./loadingPagination.vue?vue&type=style&index=0&id=8110187c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8110187c",
  null
  
)

export default component.exports